
<app-navbar customHeader="true" >
  <div class="container-fluid bg-light">
    <div class="row">
      <div class="col-12">
        <div class="text-center mt-5">
          <h2 class="title-page text-center" *ngIf="etapas === 1">Recuperar Senha</h2>
          <h2 class="title-page text-center" *ngIf="etapas === 2">Nova Senha</h2>
        </div>
        <div class="row d-flex align-center justify-content-center mt-3 p-4">
          <div class="col-8">
            <div class="text-box p-5">

              <div *ngIf="etapas === 1">
                <div class="row">
                  <span class="back-button" (click)="backStep()">
                    <i class="fas fa-arrow-left"></i> voltar
                  </span>
                </div>
                <div class="descricao mt-3 p-5">
                  <span>
                    Informe abaixo o <b>CPF</b> que utilizou no seu cadastro. Enviaremos um e-mail com um código de verificação para você redefinir sua senha.
                  </span>
                </div>
                <form class="text-left" [formGroup]="formForgotPassword">
                  <div class="form-row  d-flex align-center justify-content-center">
                    <div class="col-7">
                      <div class="form-outline">
                        <label mdbLabel class="form-label" for="form1">Documento Identificador *</label>
                        <input data-testid="cpf-recuperar-senha"
                          mask="000.000.000-00"
                          formControlName="document"
                          placeholder="000.000.000-00"
                          [dropSpecialCharacters]="true"
                          type="text"
                          id="form1"
                          class="form-control custom-input form-icon-trailing"
                        />
                        <div class="info-icon">
                          <span class="helper-text">
                            <p class="material-icons-outlined">info</p>
                            Informe apenas números (CPF)
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-12 mt-5 d-flex align-center justify-content-center">
                      <button data-testid="botao-recuperar-senha" (click)="send()" class="btn custom-btn mt-3">
                        Enviar
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div *ngIf="etapas === 2">
                <div class="row">
                  <span class="back-button" (click)="cancelarVoltar()">
                    <i class="fas fa-arrow-left"></i> voltar
                  </span>
                </div>
                <form class="p-3" [formGroup]="formPasswordToken">
                  <div class="form-row mt-5 ">
                    <h4 class="subtitle-form text-center col-12">Enviamos um código de verificação para <b>{{ userEmailMasked }}</b>.<br> Digite o código de 6 dígitos para prosseguir.</h4>
                  </div>
                  <div class="form-row mt-4 mb-3">
                      <h4 class="title-email text-center col-12">
                        Código de verificação (6 dígitos)
                      </h4>
                  </div>
                  <div>
                    <app-token-input
                    [formControl]="token"
                    [status]="tokenStatus"
                    [resendSeconds]="60"
                    (resend)="resendEmailCode()"
                    >
                    </app-token-input>
                  </div>

                  <div class="form-row d-flex mt-5 align-center justify-content-center">
                    <h3 class="title-newpassword"> Crie sua nova senha </h3>
                  </div>
                  <div class="form-row d-flex mt-1 align-center justify-content-center">
                    <div class="form-group col-md-8">
                      <label class="form-label">Nova senha *</label>
                      <div class="password-container">
                        <input
                          class="form-control custom-input"
                          [type]="mostrarSenha ? 'text' : 'password'"
                          formControlName="newPassword"
                          (input)="checkSenha()">
                        <i class="fas" [ngClass]="mostrarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenha = !mostrarSenha"></i>
                      </div>
                      <span class="error-form ml-2" *ngIf="newPassword.invalid && newPassword.errors?.required && newPassword.touched">Campo obrigatório.</span>
                      <div class="strength-wrapper mt-4" *ngIf="newPassword.value">
                        <div class="strength-bar">
                          <div class="strength-bar-fill" [ngClass]="'is-' + nivelSenha"></div>
                        </div>
                        <span class="strength-label" [ngClass]="'is-' + nivelSenha">{{ labelForca }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-row d-flex align-center justify-content-center">
                    <div class="content col-md-8">
                      <p>Sua senha deve conter:</p>
                      <ul class="requirement-list col-md-12 mt-1">
                        <li [ngClass]="{ 'text-success': checarSenha.minLength, 'text-black-50': !checarSenha.minLength }">
                          <i class="fa" [ngClass]="checarSenha.minLength ? 'fa-check' : 'fa-times'"></i>
                          <span> Mínimo 8 caracteres</span>
                        </li>
                        <li [ngClass]="{ 'text-success': checarSenha.uppercase, 'text-black-50': !checarSenha.uppercase }">
                          <i class="fa" [ngClass]="checarSenha.uppercase ? 'fa-check' : 'fa-times'"></i>
                          <span> Pelo menos 1 letra maiúscula</span>
                        </li>
                        <li [ngClass]="{ 'text-success': checarSenha.number, 'text-black-50': !checarSenha.number }">
                          <i class="fa" [ngClass]="checarSenha.number ? 'fa-check' : 'fa-times'"></i>
                          <span> Pelo menos 1 número</span>
                        </li>
                        <li [ngClass]="{ 'text-success': checarSenha.specialCharacter, 'text-black-50': !checarSenha.specialCharacter }">
                          <i class="fa" [ngClass]="checarSenha.specialCharacter ? 'fa-check' : 'fa-times'"></i>
                          <span> Pelo menos 1 destes caracteres especiais (!@#$%)</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="form-row d-flex mt-3 align-center justify-content-center">
                    <div class="form-group col-md-8">
                      <label class="form-label">Confirmar nova senha *</label>
                      <div class="password-container">
                        <input
                          [type]="mostrarConfirmarSenha ? 'text' : 'password'"
                          class="form-control custom-input"
                          [ngClass]="{  'input-erro': confirmacaoPreenchida && !senhaCorresponde,
                                        'input-ok': senhaCorresponde }"
                          formControlName="confirmNewPassword">
                        <i class="fas" [ngClass]="mostrarConfirmarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarConfirmarSenha = !mostrarConfirmarSenha"></i>
                      </div>
                      <span class="match-msg is-erro ml-2" *ngIf="confirmacaoPreenchida && !senhaCorresponde">
                        <i class="fa fa-times"></i> As senhas não correspondem
                      </span>
                      <span class="match-msg is-ok ml-2" *ngIf="senhaCorresponde">
                        <i class="fa fa-check"></i> As senhas correspondem
                      </span>
                    </div>
                  </div>

                  <div class="form-row mt-5 d-flex justify-content-center">
                    <div class="col-md text-center">
                      <button class="btn" [disabled]="!podeSalvar" (click)="validatePassword()">Salvar nova senha</button>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
        <div class="col mb-3" *ngIf="etapas === 1">
          <span class="info-text">
            <p class="mb-0">Ainda não tem cadastro? <a href="/#/cadastro" class="link-cad">Criar conta no Portal Investidor</a></p>
          </span>
        </div>
      </div>
    </div>
  </div>
</app-navbar>
<footer class="page-footer font-small custom-bg-color">
  <div class="footer-copyright text-center py-3 custom-footer">© {{currentYear}} Fundo Garantidor de Créditos - FGC. Todos os direitos reservados.</div>
</footer>
